export default __webpack_public_path__ + "static/media/DJI_0989.MP4.00_01_45_00.Still005.a93d048a.jpg";